import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAppSelector } from "../../services/store/hooks";
import OptionsMenu from "../../components/options-menu/options-menu";
import Loader from "../../components/loader/loader";
import ProfilePreviewModal from "../../components/profile-preview-modal/profile-preview-modal";
import defaultAvatar from "../../images/196m.png";
import styles from "./options.module.css";

export function OptionsPage() {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const { profile } = useAppSelector(store => store.user);
    const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        const target = e.currentTarget as HTMLImageElement;
        target.src = defaultAvatar;
    };
    if (!profile)
        return <Loader />
    return (
        <>
            <div className={styles.header}>
                <button type="button" className={styles.qrButton} aria-label="QR code">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M4 4H10V10H4V4Z" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M14 4H20V10H14V4Z" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M4 14H10V20H4V14Z" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M14 14H16.5V16.5H14V14Z" fill="currentColor" />
                        <path d="M18 14H20V16H18V14Z" fill="currentColor" />
                        <path d="M14 18H16V20H14V18Z" fill="currentColor" />
                        <path d="M18 18H20V20H18V18Z" fill="currentColor" />
                    </svg>
                </button>

                <div className={styles.headerAvatarBox}>
                    <img
                        src={profile.photos?.[0]?.url || defaultAvatar}
                        alt="Аватар"
                        className={styles.avatar}
                        onError={handleImageError}
                    />
                </div>

                <NavLink to="/profile/info" className={styles.editButton}>
                    Изм.
                </NavLink>
            </div>

            <div className={styles.container}>
                <div className={styles.box}>
                    {profile?.name}
                </div>
                <OptionsMenu onProfileClick={() => setIsProfileOpen(true)} />
            </div>

            <ProfilePreviewModal
                profile={profile}
                isOpen={isProfileOpen}
                onClose={() => setIsProfileOpen(false)}
            />
        </>
    );
}
